import ApiConfig from "../api/config/api-config";
import {CertificateApi, CertificateController$CertificateListItem} from "../api/generated/herds-certificates";
import {RegistrationJson} from "../api/generated/registry-rest";

export interface ICertificateService {
    create(registryId: string, panonId: string): Promise<string>;

    list(registration: RegistrationJson): Promise<CertificateController$CertificateListItem[]>;
}

class CertificateServiceImpl implements ICertificateService {
    constructor(private readonly certificateApi: CertificateApi) {
    }

    async create(registryId: string, panonId: string): Promise<string> {
        return (await this.certificateApi.create(registryId, panonId)).id;
    }

    async list(registration: RegistrationJson): Promise<CertificateController$CertificateListItem[]> {
        return (await this.certificateApi.list(registration.registryId, registration.panonIdentifier)).items;
    }
}

const certificateApi = new CertificateApi(new ApiConfig());
export const CertificateService: ICertificateService = new CertificateServiceImpl(certificateApi);
